/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { EISIMPORT } from '../model/eISIMPORT';
import { RESPONSEITEM } from '../model/rESPONSEITEM';
import { SUBSCRIPTIONIMPORT } from '../model/sUBSCRIPTIONIMPORT';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ImportService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Import list of cards by EIS
     * @param eisList 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCardsBatchPut(eisList: Array<EISIMPORT>, observe?: 'body', reportProgress?: boolean): Observable<Array<RESPONSEITEM>>;
    public importCardsBatchPut(eisList: Array<EISIMPORT>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RESPONSEITEM>>>;
    public importCardsBatchPut(eisList: Array<EISIMPORT>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RESPONSEITEM>>>;
    public importCardsBatchPut(eisList: Array<EISIMPORT>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eisList === null || eisList === undefined) {
            throw new Error('Required parameter eisList was null or undefined when calling importCardsBatchPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<Array<RESPONSEITEM>>(`${this.basePath}/import/cards/batch`,
            eisList,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Import single card by EIS
     * @param eis 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCardsPut(eis: EISIMPORT, observe?: 'body', reportProgress?: boolean): Observable<RESPONSEITEM>;
    public importCardsPut(eis: EISIMPORT, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RESPONSEITEM>>;
    public importCardsPut(eis: EISIMPORT, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RESPONSEITEM>>;
    public importCardsPut(eis: EISIMPORT, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eis === null || eis === undefined) {
            throw new Error('Required parameter eis was null or undefined when calling importCardsPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<RESPONSEITEM>(`${this.basePath}/import/cards`,
            eis,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Import list of profiles
     * @param profiles 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importProfilesBatchPut(profiles: Array<SUBSCRIPTIONIMPORT>, observe?: 'body', reportProgress?: boolean): Observable<Array<RESPONSEITEM>>;
    public importProfilesBatchPut(profiles: Array<SUBSCRIPTIONIMPORT>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RESPONSEITEM>>>;
    public importProfilesBatchPut(profiles: Array<SUBSCRIPTIONIMPORT>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RESPONSEITEM>>>;
    public importProfilesBatchPut(profiles: Array<SUBSCRIPTIONIMPORT>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (profiles === null || profiles === undefined) {
            throw new Error('Required parameter profiles was null or undefined when calling importProfilesBatchPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<Array<RESPONSEITEM>>(`${this.basePath}/import/profiles/batch`,
            profiles,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update MSISDNs of profiles by IMSI
     * @param imsiMsisdns List of IMSI - MSISDN pairs separated by a space - one per line
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importProfilesPost(imsiMsisdns: string, observe?: 'body', reportProgress?: boolean): Observable<RESPONSEITEM>;
    public importProfilesPost(imsiMsisdns: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RESPONSEITEM>>;
    public importProfilesPost(imsiMsisdns: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RESPONSEITEM>>;
    public importProfilesPost(imsiMsisdns: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (imsiMsisdns === null || imsiMsisdns === undefined) {
            throw new Error('Required parameter imsiMsisdns was null or undefined when calling importProfilesPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<RESPONSEITEM>(`${this.basePath}/import/profiles`,
            imsiMsisdns,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Import single profile
     * @param profile 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importProfilesPut(profile: SUBSCRIPTIONIMPORT, observe?: 'body', reportProgress?: boolean): Observable<RESPONSEITEM>;
    public importProfilesPut(profile: SUBSCRIPTIONIMPORT, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RESPONSEITEM>>;
    public importProfilesPut(profile: SUBSCRIPTIONIMPORT, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RESPONSEITEM>>;
    public importProfilesPut(profile: SUBSCRIPTIONIMPORT, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (profile === null || profile === undefined) {
            throw new Error('Required parameter profile was null or undefined when calling importProfilesPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<RESPONSEITEM>(`${this.basePath}/import/profiles`,
            profile,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/api/import.service.ts